import { render, staticRenderFns } from "./project-warehouse.vue?vue&type=template&id=18d30bae"
import script from "./project-warehouse.vue?vue&type=script&lang=js"
export * from "./project-warehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports